// src/services/aiService.js
import { supabase } from '../lib/supabase'

export const aiService = {
  async analyzeStimulus(content, subject) {
    console.log('=== STARTING AI ANALYSIS (raw content) ===')
    console.log('Content length:', content.length)
    console.log('Content preview:', content.substring(0, 100) + '...')
    console.log('Subject for analysis:', subject)

    try {
      console.log('Attempting edge function call (content)...')
      const { data, error } = await supabase.functions.invoke('analyze_stimulus', {
        body: { content, subject }
      })

      if (error) {
        console.error('Edge function error:', error)
        throw new Error(`Analysis failed: ${error.message}`)
      }

      if (!data?.success) {
        console.error('Analysis service error:', data?.error)
        throw new Error(data?.error || 'Analysis failed')
      }

      console.log('=== ANALYSIS COMPLETE (EDGE FUNCTION, content) ===')
      console.log('Number of themes received:', data.themes.length)
      console.log('Themes:', data.themes)

      if (!data.themes || data.themes.length === 0) {
        throw new Error('No themes were generated - please try with different content')
      }

      return data.themes
    } catch (error) {
      console.error('=== ANALYSIS FAILED (content) ===')
      console.error('Error:', error.message || error)
      throw error
    }
  },

  // NEW: analyze themes using a stimulusId so the edge function can pull extracted_text from DB
  async analyzeStimulusByStimulusId(stimulusId, subject) {
    console.log('=== STARTING AI ANALYSIS (by stimulusId) ===')
    console.log('StimulusId:', stimulusId)
    console.log('Subject for analysis:', subject)

    try {
      console.log('Attempting edge function call (stimulusId)...')
      const { data, error } = await supabase.functions.invoke('analyze_stimulus', {
        body: { stimulusId, subject }
      })

      if (error) {
        console.error('Edge function error:', error)
        throw new Error(`Analysis failed: ${error.message}`)
      }

      if (!data?.success) {
        console.error('Analysis service error:', data?.error)
        throw new Error(data?.error || 'Analysis failed')
      }

      console.log('=== ANALYSIS COMPLETE (EDGE FUNCTION, stimulusId) ===')
      console.log('Number of themes received:', data.themes.length)
      console.log('Themes:', data.themes)

      if (!data.themes || data.themes.length === 0) {
        throw new Error('No themes were generated - please try with different content')
      }

      return data.themes
    } catch (error) {
      console.error('=== ANALYSIS FAILED (stimulusId) ===')
      console.error('Error:', error.message || error)
      throw error
    }
  },

  async generateLessonPlan(stimulusContent, themes, lessonDesign) {
    // This function is now handled by the edge function
    console.log('Lesson plan generation should use edge function')
    return { plans: [] }
  },

  async generateResources(lessonPlan, lessonDesign) {
    // This function is now handled by the edge function
    console.log('Resource generation should use edge function')
    return []
  }
}